
const return_spread = (spread) => {
    if (spread > 0) {
        return ''
    } else {
        return spread
    }
}

export default return_spread